var map = {
	"./en-US.json": [
		68003,
		3
	],
	"./es-AR.json": [
		15659,
		659
	],
	"./es-VE.json": [
		28141,
		141
	],
	"./pt-BR.json": [
		5101,
		101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 68497;
module.exports = webpackAsyncContext;